<template>
  <div>
    <div v-if="showMainContainer">
      <div class="price-container">支付金额:<span>￥{{amount}}</span></div>
      <div style="padding: 10px 30px;">
        <div class="item">
          <label>银行</label>
          <select style="width: 100%" v-model="postData.bankID">
            <option v-for="(item) in bankIdList" :key="item.bank_id" :value="item.bank_id">{{ item.bank_name }}</option>
          </select>
        </div>
        <div class="item">
          <label>卡号</label>
          <input
              type="text"
              placeholder="卡号"
              v-model="postData.pan"
          />
        </div>
        <div class="item">
          <label>类型</label>
          <select style="width: 100%" v-model="postData.cardType">
            <option value="1">借记卡</option>
            <option value="2">信用卡</option>
          </select>
        </div>
        <div class="item" v-if="Number(postData.cardType) === 2">
          <label>有效期</label>
          <input
              type="text"
              placeholder="月份/年份 如0821"
              v-model="postData.expiredDate"
          />
        </div>
        <div class="item" v-if="Number(postData.cardType) === 2">
          <label>CVV2</label>
          <input
              type="text"
              placeholder="卡背面签名栏后三位"
              v-model="postData.cvv2"
          />
        </div>
        <div class="item">
          <label>姓名</label>
          <input
              type="text"
              placeholder="持卡人姓名"
              v-model="postData.cardHolderName"
          />
        </div>
        <div class="item">
          <label>身份证</label>
          <input
              type="text"
              placeholder="持卡身份证号码"
              v-model="postData.cardHolderId"
          />
        </div>
        <div class="item">
          <label>手机号</label>
          <input
              type="text"
              placeholder="银行预留手机号"
              v-model="postData.phoneNo"
          />
        </div>
        <div class="item" v-if="!cardBound">
          <input
              v-if="smsRequired"
              type="text"
              placeholder="短信验证码"
              v-model="postData.validCode"
          />
          <button class="valid-code-btn" :class="{'full-width-btn': !smsRequired}" @click="sendBindSms()" :disabled="smsBtnDisabled">{{ smsBtn }}</button>
        </div>
        <button class="confirm-bind-btn" v-if="!cardBound && smsRequired" :disabled="confirmBtnDisabled" @click="confirmBindCard()">{{ confirmBtn }}</button>
        <button class="pay-btn" :disabled="payBtnDisabled" @click="submitPay()">{{ payBtn }}</button>
      </div>
    </div>
    <div v-else>
      <div class="success-container">
        <img src="~@/assets/images/success.png" alt="">
        <div class="success-text">支付成功</div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/http/request'
import { getOrderInfo, payOrder as apiPayOrder } from '@/api/api'
import bankIdList from './bank-id.json'

const smsBtnText = '获取验证码';
const confirmBtnText = '确认绑卡';

const payBtnText = '支付';

const timeout = 60;

export default {
  name: "Fastpay",
  data() {
    return {
      showMainContainer: true,
      amount:'0.00',
      orderToken: '',
      ifCode: '',
      smsBtnDisabled: false,
      confirmBtnDisabled: false,
      payBtnDisabled: false,
      bankIdList,
      postData: {
        bankID: '',
        pan: '',
        cardHolderName: '',
        cardHolderId: '',
        phoneNo: '',
        cardType: 1,
        expiredDate: '',
        cvv2: '',
        token:'',
        validCode:''
      },
      smsBtnTimeoutKey: -1,
      smsBtnKey: -1,
      smsBtn: smsBtnText,
      confirmBtn: confirmBtnText,
      smsSent: false,
      smsRequired: true,
      payBtn: payBtnText,
      cardBound: false,
      delay: timeout,
      payBtnTimeoutKey: -1,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    isMobileDevice: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    init() {
      const {ifCode, token} = this.$router.history.current.params;
      this.orderToken = token;
      this.ifCode = ifCode;
      if (token) {
        getOrderInfo(token).then(info => {
          this.amount = info.amount / 100;
        })
      }
    },
    check() {
      const cardType = Number(this.postData.cardType)
      if (cardType === 1) {
        if (this.postData.bankID === '' ||
            this.postData.pan === '' ||
            this.postData.cardHolderName === '' ||
            this.postData.cardHolderId === '' ||
            this.postData.phoneNo === '') {
          return false;
        }

      } else if (cardType === 2) {
        if (this.postData.bankID === '' ||
            this.postData.pan === '' ||
            this.postData.cardHolderName === '' ||
            this.postData.cardHolderId === '' ||
            this.postData.phoneNo === '' ||
            this.postData.expiredDate === '' ||
            this.postData.cvv2 === '')
        {
          return false;
        }
      }
      return true;
    },
    sendBindSms(){
      this.startSmsCooldown()

      this.smsBtnTimeoutKey = setTimeout(() => {
        if (this.smsBtnKey !== -1){
          clearTimeout(this.smsBtnTimeoutKey)
        }

        if (this.postData.pan.length < 12){
          alert('请输入正确的银行卡号')
          this.resetSmsBtn()
          return
        }

        if (this.postData.phoneNo.length < 11){
          alert('请输入正确的手机号')
          this.resetSmsBtn()
          return
        }

        if (this.check()) {
          request.request({
            url: `/api/card/bind/${this.ifCode}/${this.orderToken}`,
            method: 'POST',
            data: this.postData
          }).then(res => {
            this.postData.token = res.token || res.bindingTxSN
            if (res.bindStatus === 'success' && res.smsRequired === false) {
              this.smsRequired = false
              this.cardBound = true
              this.smsSent = false
              alert('该卡已签约，可直接支付')
            } else {
              this.smsRequired = true
              this.smsSent = true
              this.cardBound = false
              alert('验证码已发送，请查收短信')
            }
            this.resetSmsBtn()
          }).catch(err => {
            console.log(err)
            this.smsSent = false
            this.resetSmsBtn()
          });
        } else {
          this.resetSmsBtn()
        }

      },300)
    },
    confirmBindCard() {
      if (!this.smsSent || this.postData.token === '') {
        alert('请先获取短信验证码')
        return
      }
      if (this.postData.validCode === '') {
        alert('请输入短信验证码')
        return
      }
      if (!this.check()) {
        return
      }

      this.confirmBtnDisabled = true
      this.confirmBtn = '绑卡中...'

      request.request({
        url: `/api/card/bind/confirm/${this.ifCode}/${this.orderToken}`,
        method: 'POST',
        data: this.postData
      }).then(res => {
        this.postData.token = res.token || res.bindingTxSN
        this.cardBound = true
        alert('绑卡成功')
      }).catch(err => {
        console.log(err)
        this.cardBound = false
      }).finally(() => {
        this.confirmBtnDisabled = false
        this.confirmBtn = confirmBtnText
      })
    },
    startSmsCooldown(){
      this.smsBtnDisabled = true;
      this.smsBtnKey = setTimeout(() => {
        if (this.delay <= 0) {
          this.resetSmsBtn()
        } else {
          this.delay--
          this.smsBtn = `(${this.delay}s)后重新获取`
          this.startSmsCooldown()
        }
      }, 1000)
    },
    resetSmsBtn(){
      clearTimeout(this.smsBtnKey)
      this.delay = timeout
      this.smsBtn = smsBtnText
      this.smsBtnKey = -1;
      this.smsBtnDisabled = false;
    },
    submitPay() {
      if (!this.cardBound || this.postData.token === '') {
        alert('请先完成绑卡')
        return
      }
      if (!this.check()) {
        return
      }

      this.payBtnDisabled = true;
      this.payBtn = '支付中...';
      this.payBtnTimeoutKey = setTimeout(() => {
        if (this.payBtnTimeoutKey !== -1) {
          clearTimeout(this.payBtnTimeoutKey)
          this.payBtnDisabled = false;
        }

        apiPayOrder(this.orderToken, {channelExtra: JSON.stringify(this.postData)})
            .then(res => {
              if (res.code !== undefined && res.code !== 0) {
                return alert(`支付失败: ${res.msg}`)
              }

              if (res && (res.orderState === 1 || res.orderState === 2)) {
                if (res.orderState === 1) {
                  this.showMainContainer = false;
                } else {
                  alert('支付受理成功，请稍候查询结果')
                }
              } else {
                alert(res.errMsg || res.msg || '支付失败')
              }
            })
            .catch(() => {
              alert('支付失败')
            })
            .finally(() => {
              this.payBtn = payBtnText
            });
      }, 300)
    }
  },
}
</script>

<style>

.success-container {
  margin-top: 100px;
}

.price-container {
  padding: 10px 20px;
  font-size: 45px;
  background-color: red;
  margin-bottom: 18px;
}

.price-container span {
  color: white;
  margin-left: 10px;
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.item > label {
  width: 150px;
  font-size: 30px;
}

.item > input, .item > select {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px;
  font-size: 30px;
}

.valid-code-btn{
  width: 390px;
  background-color: rgba(107,154,255,1);
  border: 3px solid rgba(0,0,0,0.1);
  color: white;
  padding: 15px 0;
  margin-left: 10px;
  border-radius: 5px;
}

.valid-code-btn:active {
  background-color: rgba(107,154,255,0.6)
}

.full-width-btn {
  width: 100%;
  margin-left: 0;
}

.confirm-bind-btn {
  width: 100%;
  background-color: rgba(82, 196, 26, 1);
  font-size: 30px;
  color: white;
  border: 3px solid rgba(0,0,0,0.1);
  padding: 15px 0;
  margin-bottom: 20px;
  border-radius: 5px;
}

.confirm-bind-btn:active {
  background-color: rgba(82, 196, 26, 0.6);
}

.pay-btn {
  width: 100%;
  background-color: rgba(107,154,255,1);
  font-size: 30px;
  color: white;
  border: 3px solid rgba(0,0,0,0.1);
  padding: 15px 0;
  border-radius: 5px;
}
.pay-btn:active {
  background-color: rgba(255,0,0,0.6);
}
</style>